import React from 'react';
import './SuccessModal.css';

const SuccessModal = ({ isOpen, userId, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="success-modal-overlay">
      <div className="success-modal">
        {/* Success Icon */}
        <div className="success-icon">
          <svg
            width="80"
            height="80"
            viewBox="0 0 80 80"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="40" cy="40" r="38" fill="#e8f5e9" stroke="#4caf50" strokeWidth="2" />
            <path
              d="M25 40L35 50L55 30"
              stroke="#4caf50"
              strokeWidth="4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        {/* Success Message */}
        <h2 className="success-title">Account Created Successfully! 🎉</h2>
        
        <div className="success-details">
          <p className="success-message">
            Your account has been created successfully.
          </p>
          
          <div className="user-info">
            <label>Your User ID:</label>
            <div className="user-id-box">
              <code>{userId}</code>
              <button
                className="copy-btn"
                onClick={() => {
                  navigator.clipboard.writeText(userId);
                  alert('User ID copied to clipboard!');
                }}
                title="Copy User ID"
              >
                📋 Copy
              </button>
            </div>
          </div>

          <p className="next-steps">
            You can now log in with your username and password.
          </p>
        </div>

        {/* Action Button */}
        <button className="success-button" onClick={onClose}>
          ✨ Got It! Let Me Login
        </button>
      </div>
    </div>
  );
};

export default SuccessModal;
